import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.title',
    defaultMessage: 'Overview Page',
  },
  coordinator: {
    id: 'containers.OrderPage.components.OverviewPage.coordinator.label',
    defaultMessage: 'P.M. (Primary)',
  },
  cccoordinator: {
    id: 'containers.OrderPage.components.OverviewPage.cccoordinator.label',
    defaultMessage: 'P.M. (Secondary)',
  },
  contact: {
    id: 'containers.OrderPage.components.OverviewPage.contact.label',
    defaultMessage: 'Contact (Primary)',
  },
  cccontact: {
    id: 'containers.OrderPage.components.OverviewPage.cccontact.label',
    defaultMessage: 'Contact (Secondary)',
  },
  userPlaceholder: {
    id: 'containers.OrderPage.components.OverviewPage.userPlaceholder',
    defaultMessage: 'Select a user',
  },
  relationPlaceholder: {
    id: 'containers.OrderPage.components.OverviewPage.relationPlaceholder',
    defaultMessage: 'Click to add +',
  },
  mediaTypes: {
    id: 'containers.OrderPage.components.OverviewPage.mediaTypes.label',
    defaultMessage: 'Media',
  },
  audioFormatTypes: {
    id: 'containers.OrderPage.components.OverviewPage.audioFormatTypes.label',
    defaultMessage: 'Audio format',
  },
  services: {
    id: 'containers.OrderPage.components.OverviewPage.services.label',
    defaultMessage: 'Services',
  },
  orderUsageType: {
    id: 'containers.OrderPage.components.OverviewPage.orderUsageType.label',
    defaultMessage: 'Airing time',
  },
  products: {
    id: 'containers.OrderPage.components.OverviewPage.products.label',
    defaultMessage: 'Products',
  },
  orderId: {
    id: 'containers.OrderPage.components.OverviewPage.orderId',
    defaultMessage: 'Order ID',
  },
  dealId: {
    id: 'containers.OrderPage.components.OverviewPage.dealId',
    defaultMessage: 'Deal ID',
  },
  customer: {
    id: 'containers.OrderPage.components.OverviewPage.customer',
    defaultMessage: 'Customer',
  },
  partner: {
    id: 'containers.OrderPage.components.OverviewPage.partner',
    defaultMessage: 'Partner',
  },
  deadline: {
    id: 'containers.OrderPage.components.OverviewPage.deadline',
    defaultMessage: 'Deadline',
  },
  po: {
    id: 'containers.OrderPage.components.OverviewPage.po',
    defaultMessage: 'P.O. / Purchase Order',
  },
  status: {
    id: 'containers.OrderPage.components.OverviewPage.status',
    defaultMessage: 'Status',
  },
  emptyOrderName: {
    id: 'containers.OrderPage.components.OverviewPage.emptyOrderName',
    defaultMessage: 'Untitled',
  },
})
